import {Component, Input} from '@angular/core';
import {routesNames} from '@app/app-routing.module';
import {PromotionDetailItem} from '@app/core/promotion/domain/dtos/promotion-detail-item';
import {PromotionDetailViewModel} from '../promotion-detail.view-model';
import {PresentationConstants} from "@app/presentation/presentation.constants";

@Component({
  selector: 'app-promotion-detail-product-tile',
  templateUrl: './promotion-detail-product-tile.component.html',
  styleUrls: ['./promotion-detail-product-tile.component.scss']
})
export class PromotionDetailProductTileComponent {

  @Input() product?: PromotionDetailItem;

  canDisplayPrices$ = this.viewModel.canDisplayPrices$;

  routesNames = routesNames;

  constructor(
    private viewModel: PromotionDetailViewModel
  ) { }

    protected readonly PresentationConstants = PresentationConstants;
}
